// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import {Http, Storage, Session, TokenManager} from "vuezx";
import FastClick from 'zxclick'
import App from '@/App'
import router from '@/router'
// 插件
import * as filters from '@/filters'
import title from '@/components/directive/directive'
import store from '@/store'
import VueClipboard from 'vue-clipboard2'
import infiniteScroll from 'vue-infinite-scroll'
import 'babel-polyfill'
import Es6Promise from 'es6-promise'

Es6Promise.polyfill()
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: Storage.get('language') == null ? "cn" : Storage.get('language'),    // 语言标识
  messages: {
    'cn': require('@/utils/lang/cn'),   // 中文语言包
    'en': require('@/utils/lang/en')    // 英文语言包
  },
})
import commonUtil from '@/pages/common/common.js';
/*const zoeMain = require("@/build/main");
if (!global.localConfig) {
  // 非本地环境
  zoeMain({
    name: 'hospital',
    env: 'dev3',
    type: 'app',
    port: 4004,
    reloadPort: 9857,
    mounted(app) {
    }
  });
}*/
const setConfig = require("@/fetch/setConfig.json");
const setConfigTest = require("@/fetch/setConfigTest.json");
global.zoeConfig = (process.env.NODE_ENV === 'development' ? setConfigTest[process.env.VUE_APP_API].zoeConfig : setConfig[process.env.VUE_APP_API].zoeConfig)
global.localConfig = (process.env.NODE_ENV === 'development' ? setConfigTest[process.env.VUE_APP_API].localConfig : setConfig[process.env.VUE_APP_API].localConfig)
/**
 * 配置常量
 */
global.proxy = process.env.NODE_ENV === 'development' ? false : false;
//测试线使用代理解决跨域，测试线域名有变动,链接本地不使用代理改成false
global.API_BASE_PATH = process.env.VUE_APP_BASE_API;
// global.API_BASE_PATH = "https://8080.zx.zoenet.cn";
// global.API_BASE_PATH = "https://3003.zx.dev.zoenet.cn/8080";
// global.BASE_PATH = "https://3003.zx.zoenet.cn";
global.BASE_PATH = process.env.VUE_APP_UI_URL;
global.APP_NAME = '智业健康'
global.APP_TITLE = '智业健康'
global.UPLOAD_PATH = process.env.VUE_APP_UPLOAD_PATH;
global.WECHAT_APP_ID = process.env.VUE_APP_WECHAT_APP_ID;
// 图片地址API
global.IMG_BASE_API_PATH =
window.location.protocol.indexOf('https:')>-1?"https://img.zx.zoenet.cn/":"http://img.zx.zoenet.cn/";
// 图片地址
global.IMG_BASE_PATH =  window.location.protocol.indexOf('https:')>-1?"https://img.zx.zoenet.cn/":"http://img.zx.zoenet.cn/";

// 测试
global.DEBUG = false
// appId,orgCode只添加headers
global.appIdHeaders = true
// 刷新token地址
global.REFRESH_TOKEN_URI = "";
global.APP_NAME = "智业健康";
global.APP_TITLE = "智业健康";
global.DEFAULT_AVATAR = "/static/images/common/default-avatar.png";
global.PAGE_SIZE = 20;
global.TOKEN_CACHE_KEY = "token";
import common from '@/common/common';
import version from '@/common/config';
// 全局引入UI库 vant
// 轻弹窗
import {
  Toast
} from 'vant';
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);
import {Dialog} from 'vant'

Vue.use(VueClipboard)
Vue.use(infiniteScroll)
// 引入vue-amap
/* import VueAMap from 'vue-amap';
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: 'YOUR_KEY',
  // 插件集合
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4'
}); */
// 聚焦元素
Vue.directive('focus', {
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})
// 解决移动端点击延迟200ms的问题
if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    FastClick.attach(document.body);
  }, false);
}
//appId对应名称没有返回appIdEmpty
global.checkAppId = function () {
  let name;
  for (let [key, value] of Object.entries(version)) {
    if (value.appId == global.appId) {
      name = key
    }
  }
  return name ? name : 'appIdEmpty'
}
//返回appcodoname
global.checkAppCodeName = function () {
  return Session.get('appversion').appCodeName
}
//token失效是否跳转第三方登录
global.checkAppLogin = function () {
  return Session.get('appversion').appLogin
}
// 混合平台判断
global.appTokenFlag = function (to) {
  let currentRoute;
  to ? currentRoute = to : currentRoute = router.currentRoute
  // (混合版) npVerifyToken npOrgCode npAppCode
  if (currentRoute.query.hasOwnProperty("npVerifyToken") && currentRoute.query.hasOwnProperty("npOrgCode") && currentRoute.query.hasOwnProperty("npAppCode")) {
    // 设置登录请求参数
    global.setLoginParams('np', currentRoute)
    Storage.set('loginType', 'np')
    return true
  }
  // 艾嘉APP verifyToken orgCode appCode
  else if (currentRoute.query.hasOwnProperty("verifyToken") && currentRoute.query.hasOwnProperty("orgCode") && currentRoute.query.hasOwnProperty("appCode")) {
    // 设置登录请求参数
    global.setLoginParams('ij', currentRoute)
    Storage.set('loginType', 'ij')
    return true
  } else if (Storage.get('loginType') == 'np' || Storage.get('ij') == 'np') {
    return true
  } else {
    return false
  }
}
// 设置登录请求参数 存储参数
global.setLoginParams = function (type, currentRoute) {
  let data;
  if (type == 'np') {
    data = {
      npToken: currentRoute.query.npVerifyToken,
      npOrgCode: currentRoute.query.npOrgCode,
      npAppCode: currentRoute.query.npAppCode,
      platformSingleHospital: currentRoute.query.platformSingleHospital || 1,
      betaMLXM: currentRoute.query.betaMLXM,
    };
  }
  if (type == 'ij') {
    data = {
      ijToken: currentRoute.query.verifyToken,
      ijOrgCode: currentRoute.query.orgCode,
      ijAppCode: currentRoute.query.appCode,
    };
  }
  // 存储参数
  Session.set('npLoginParams', JSON.stringify(data));
  return data
},
// 从APP进入带参数请求token 登录
  global.getAppToken = function (success, to) {
    let currentRoute;
    to ? currentRoute = to : currentRoute = router.currentRoute
    let config = {};
    config.success = function (response) {
      return success(response)
    };
    // 健康城市存储参数 入参&npVerifyToken=${npVerifyToken}&npOrgCode=${npOrgCode}&npAppCode=${npAppCode}
    // 艾嘉APPP存储参数 入参&verifyToken=${verifyToken}&orgCode=${orgCode}&appCode=${appCode}
    if ((currentRoute.query.hasOwnProperty("npVerifyToken") && currentRoute.query.hasOwnProperty("npOrgCode") && currentRoute.query.hasOwnProperty("npAppCode")) || (Storage.get('loginType') == 'np' && Session.get('npLoginParams'))) {
      config.url = '/account/npLogin'
      config.hsyHosName = Session.get('appversion').hosName
      config.params = {}
      // 混合平台判断
      global.appTokenFlag()
      // 存储参数
      Object.assign(config.params, Session.get('npLoginParams'))
      // 没有npVerifyToken去登录 npVerifyToken失效了
      if ((!currentRoute.query.npVerifyToken) && !(Storage.get('loginType') == 'np' && Session.get('npLoginParams'))) {
        // 新平台登录或者跳转健康城市中转站
        global.appLogin(config)
      } else {
        // 新平台登录获取token
        store.dispatch('loginInit', config);
      }
      return
    }
    // 艾嘉APP
    if ((currentRoute.query.hasOwnProperty("verifyToken") && currentRoute.query.hasOwnProperty("orgCode") && currentRoute.query.hasOwnProperty("appCode")) || (Storage.get('loginType') == 'ij' && Session.get('npLoginParams'))) {
      config.url = '/account/ijLogin'
      config.params = {}
      // 存储参数
      Object.assign(config.params, Session.get('npLoginParams'))
      // 没有verifyToken去登录 verifyToken失效了
      if (!currentRoute.query.verifyToken && !(Storage.get('loginType') == 'ij' && Session.get('npLoginParams'))) {
        // 新平台登录或者跳转健康城市中转站
        global.appLogin(config)
      } else {
        // 新平台登录获取token
        store.dispatch('loginInit', config);
      }
    }
  }
// 新平台登录或者跳转健康城市中转站
global.appLogin = function (config) {
  let configV2 = config;
  if (!config && Session.get('npLoginParams')) {
    configV2 = {
      params: {
        npAppCode: Session.get('npLoginParams').npAppCode || Session.get('npLoginParams').ijAppCode,
        npOrgCode: Session.get('npLoginParams').npOrgCode || Session.get('npLoginParams').ijOrgCode,
        npToken: Session.get('npLoginParams').npToken || Session.get('npLoginParams').ijToken,
        hsyHosName: Session.get('appversion').hosName
      }
    }
  }
  if (!configV2) {
    return
  }
  // 登录
  let h5Fuc = function () {
    let locationSource;
    // 新平台登录
    if (global.checkAppLogin()) {
      locationSource = process.env.VUE_APP_health
      // locationSource = 'https://public.health.zoenet.cn/'
      // hsyHosCode:三亚的区域代码（460200）
      // hsyHosName: 三亚市
      // hsyLink: 火烧云地址（为避免微信地址转换出问题，需要传encode之后的链接）
      // appCode:产品线（HC_SANYA_WX）
      let appCode, hsyHosName, npOrgCode, hsyLink, loginLink;
      appCode = configV2.params.npAppCode;
      npOrgCode = configV2.params.npOrgCode;
      hsyHosName = configV2.hsyHosName;
      hsyLink = encodeURIComponent(location.href);
      console.log(location.href)
      loginLink = `${locationSource}health-city/evening-glow/evening-glow?hsyHosCode=${npOrgCode}&hsyHosName=${hsyHosName}&hsyLink=${hsyLink}&appCode=${appCode}&orgCode=${npOrgCode}&zoneCode=${Session.get('appversion').zoneCode}&zoneName=${Session.get('appversion').zoneName}&verifyType=1`
      console.log(loginLink)
      location.href = loginLink
    }
  }
  let iosData = {
    "type": "loginView",
    "param": null
  }
  global.callAPPFunction(iosData, iosData, h5Fuc);
}
global.authorize = function (type, authorizeVal, to, actionType) {
  let currentRoute;
  to ? currentRoute = to : currentRoute = router.currentRoute
  // token失效
  let config = {};
  // 混合平台跳转
  let appFlag = global.appTokenFlag(currentRoute)
  if (appFlag) {
    // 1刷新页面 3不刷新页面
    if (actionType == 1 || actionType == 3) {
      // 验证token是否过期
      return global.getCheckToken(currentRoute, actionType)
    }
    // 接口返回报错不需要校验token是否过期
    if (actionType == 2) {
      if (global.appLoginIng) {
        return
      }
      config.success = function (response) {
        global.appReload()
      };
      global.appLoginIng = true
      // app登录
      global.getAppToken(config.success, currentRoute);
    }
    return
  }
  // 获取当前页带参数的url
  var referer = currentRoute.fullPath;
  // 获取当前页url
  var path = currentRoute.path;
  var query = currentRoute.query;
  //判断是不是登录页，保存上一级页面路径
  if (path && path != '' && path != null && path != undefined && path != '/wechatLogin') {
    sessionStorage.setItem('referer', referer)
  }
  // 跳转授权页面
  var href = global.BASE_PATH + '/#/wechatLogin'
  // 带上自定义参数,带上上一级的appId
  let data = {
    authorizeVal: authorizeVal,
    appId: global.appId
  }
  let currentUrl = encodeURIComponent(global.setUrl(href, data, true));
  let redirectUrl = encodeURIComponent(global.API_BASE_PATH + '/account/redirect?paramtype=hash&uri=' + currentUrl);
  // 0静默授权snsapi_base 1非静默授权snsapi_userinfo
  let snsapiType;
  type == 0 ? snsapiType = 'snsapi_base' : snsapiType = 'snsapi_userinfo';
  // 获取appid
  if (Storage.get('WECHAT_APP_ID')) {
    global.WECHAT_APP_ID = Storage.get('WECHAT_APP_ID')
  }
  // 身份选择页不跳转授权
  if (path == '/health/identityChoice') {
    return
  }
  // 后台系统跳转思明健康登录页面
  let checkAppId = global.checkAppId()
  if (checkAppId == 'SYSTEM') {
    if (path != '/common/login') {
      // 医生端 // 企业端
      if (query.toLogin) {
        router.replace(`/common/login?redirect=${referer}`);
      }
    }
    return
  }
  // debug模式停止跳转授权
  if (global.DEBUG) {
    return
  }
  // 从app进入非微信停止跳转授权 1 IOS 、 2 安卓 、3 微信
  if (common.entranceFlag() && common.entranceFlag() != 3) {
    return
  }
  // 清空token
  TokenManager.clear();
  window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + global.WECHAT_APP_ID +
    '&redirect_uri=' + redirectUrl + '&response_type=code&scope=' + snsapiType + '&state=1#wechat_redirect';
};
// 登录默认0静默授权snsapi_base
global.login = function () {
  global.authorize(0)
}
// 加载
global.loadingShow = function () {
  store.dispatch('showLoading', true);
}

// 加载结束
global.loadingHide = function () {
  store.dispatch('showLoading', false);
}

// 系统维护
global.sysLocked = function () {
  // global.showError('系统维护')
  // router.push('/maintenance')
}
// 获取上传token
global.getUploadUrl = function () {
  return global.IMG_BASE_API_PATH
}

// 错误提示
global.showError = function (message) {
  Toast(message);
}

// 成功提示
global.showSuccess = function (message) {
  Toast.success(message);
}
// 提示
global.toast = function (message) {
  Toast(message);
}
// 加载
global.loading = {
  show() {
    Toast.loading({
      forbidClick: true,
      loadingType: 'spinner',
      duration: 3000
    });
  },
  hide() {
    Toast.clear()
  }
}

// 获取cookie cname => cookie key名称
global.getCookie = function (cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();

    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return null;
}

// 请先设置本信息
global.setbabyinfo = function (response,config) {
  // 没有宝宝信息
  if (response.message == '请添加宝宝信息') {
    Dialog.confirm({
      title: '提示',
      message: '请先设置你的预产期',
      confirmButtonText: '去设置',
      cancelButtonText: '关闭'
    }).then(() => {
      router.push({
        path: '/maternal/setduedate',
        query: {
          backStep: -1, infoType: 'infoType3'
        }
      })
    }).catch(() => {
      if (config && config.setBabyPage == 1) {
        // 请先设置本信息跳转页面
        global.setDuedateEmpty(response)
      }
    });
    return
  }
  // 没有孩子信息
  if (response.message == '请添加孩子信息') {
    Dialog.confirm({
      title: '提示',
      message: '请先设置宝宝基本信息',
      confirmButtonText: '去设置',
      cancelButtonText: '关闭'
    }).then(() => {
      router.push({
        path: '/baby/setbabyinfo',
        query: {
          backStep: -1, infoType: 'infoType3'
        }
      })
    }).catch(() => {
      if (config && config.setBabyPage == 1) {
        // 请先设置本信息跳转页面
        global.setDuedateEmpty(response)
      }
    });
  }
}

// 请先设置本信息跳转页面
global.setDuedateEmpty = function (response) {
  // 没有宝宝信息
  if (response.message == '请添加宝宝信息') {
    router.replace(global.replacePath(`/maternal/setduedateempty?type=1`))
    return
  }
  // 没有孩子信息
  if (response.message == '请添加孩子信息') {
    router.replace(global.replacePath(`/maternal/setduedateempty?type=2`))
  }
}
//app路由刷新
global.appReload = function () {
  router?.currentRoute?.matched[0]?.instances?.default?.reload()
  global.appLoginIng = true
}
// 对应code操作
global.httpCode = function (response, config) {
  if (response.code && response.code == '2003') {
    // 请先设置基本信息
    global.setbabyinfo(response,config)
    return
  }
  if (response.code && response.code == '2004' || response.code == '1001') {
    // 登录刷新页面
    global.authorize(0, null, null, 2)
    return
  }
  //errorHide 1错误不提示
  if (!(response.code == 0 || (config && config.errorHide == 1))) {
    if(response.message){
      Toast(response.message);
    }
  }
}

// 获取服务所需参数
global.getRoute = async function (to) {
  let config = {}
  config.params = commonUtil.deepCopy(to.query)
  if (!config.params.version) {
    config.params.version = '1.0'
  }
  if (!to.query.systemType && !config.params.systemCode && to.meta.systemCode) {
    config.params.systemCode = to.meta.systemCode
  }
  delete config.params.loginType
  delete config.params.needAppId
  delete config.params.replace
  delete config.params.returnUrl
  global.url = ''
  // 加载
  global.loadingShow();
  return store.dispatch('routeInit', config).then((response) => {
    if (response.message == 'success') {
      // 加载结束
      global.loadingHide();
      // 保存版本信息
      Session.set('appversion', response.data)
      // 跳转地址
      if (response.data.url) {
        let params = global.getSearchParams(response.data.url)
        delete params.needAppId
        delete params.token
        delete params.replace
        delete params.loginType
        global.url = global.setUrl(response.data.url.split('?')[0], params, true)
      }
      // 登录方式
      Storage.set('loginType', response.data.loginType)
      // 保存appId
      let systemType = config.params.systemType || to.systemType
      global.appId = response.data.appId || (systemType && response.data[systemType].appId)
      Session.set('appId', global.appId)
    }
  })
}
// 验证token是否过期
global.getCheckToken = function (to, actionType) {
  return new Promise((resolve, reject) => {
    let config = {}
    config.to = to
    // 加载
    global.loadingShow();
    config.success = function (response) {
      // 加载结束
      global.loadingHide();
      // 跳转
      if (global.url && to && to.query && !to.query.appId && !actionType) {
        router.replace(global.replacePath(global.url))
      }
      //刷新页面
      if (actionType == 1) {
        global.appReload()
      }
      resolve(true);
    };
    store.dispatch('checkTokenInit', config)
  });
}
// 过滤
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.prototype.$http = Http
Vue.prototype.ajax = Http.execute
Vue.prototype.toast = global.toast
Vue.prototype.showError = global.showError
Vue.prototype.showSuccess = global.showSuccess
Vue.prototype.loading = global.loading
Vue.prototype.setDocumentTitle = global.setDocumentTitle
Vue.prototype.setWin = global.setWin
Vue.prototype.TokenManager = TokenManager
Vue.prototype.Storage = Storage
Vue.prototype.Session = Session
Vue.prototype.version = version
Vue.prototype.language = Storage.get('language') == null ? "cn" : Storage.get('language')
Vue.prototype.english = Storage.get('language') == 'en' ? 1 : 0
//是否测试线
Vue.prototype.envFlag = process.env.VUE_APP_envFlag == null ? false : true
Vue.prototype.common = common
Vue.config.devtools = true
// 路由切换带上appId(机构id) 进入页面
router.beforeResolve(async (to, from, next) => {
  let systemType = to.query.systemType
  let currentRoute = []
  if (!to.query.systemType) {
    //当前地址路由信息
    currentRoute = router.options.routes.filter((item, index) => {
      return item.path === to.path
    })
    if (currentRoute.length && currentRoute[0].systemType) {
      systemType = currentRoute[0].systemType
    }
  }
  let appversionFlag = (to.path == "/common/route" || systemType || (!Session.get('appversion') && to.meta.systemCode))
  // 获取服务所需参数
  if (appversionFlag) {
    await global.getRoute({...to, ...{'systemType': systemType}})
    // 验证token是否过期
    await global.getCheckToken(to)
  }
  // 设置全局appId
  const appId = from.query.appId || global.appId || Session.get('appId')
  global.appId = appId
  // 混合平台跳转
  let appFlag = global.appTokenFlag(to)
  // 还未登录3不刷新页面
  if (!TokenManager.get() && appFlag) {
    await global.authorize(0, null, to, 3);
  }
  if (to.query.appId) {
    next(true)
    return
  }
  // 不需要添加appId
  if ((to.query.needAppId != undefined && to.query.needAppId != null && to.query.needAppId != '') && to.query.needAppId ==
    '0') {
    next(true)
    return
  }
  // 此处通过修改push给query增加appId的方式, 会重置跳转数据.
  // 这会影响到replace跳转, 导致变成正常push跳转.
  // 如果原跳转是replace方式, 需要在query里主动添加appId. 避免被重置数据.
  // 跳转不需要添加appId
  if (appId && (appId !== to.query.appId) && !appversionFlag) {
    // 如果传递了appId 走正常路由
    // 否则先手动添加appId参数
    if (!to.query.appId) {
      to.query.appId = appId
      // 是否是replace方式进入
      let replace;
      to.query.hasOwnProperty("replace") ? replace = true : replace = false
      // 参数地址去掉
      if (replace) {
        delete to.query.replace
      }
      next({
        path: to.path,
        query: to.query,
        replace: replace
      })
      return false
    } else {
      next(true)
    }
  } else {
    next(true)
  }
})

// 微信复制链接无法复制 离开页面
router.afterEach((to, from) => {
  // 是否从APP进入
  if (to.query.npAppCode || to.query.appCode) {
    let ijnpAppCode = to.query.npAppCode || to.query.appCode
    //1 IOS
    if (ijnpAppCode.indexOf('IOS') > -1) {
      Session.set('appIOSFlag', true);
      Session.set('entranceFlag', 1);
    }
    // 2 安卓
    if (ijnpAppCode.indexOf('ADR') > -1) {
      Session.set('appADRFlag', true);
      Session.set('entranceFlag', 2);
    }
    // 3 微信
    if (ijnpAppCode.indexOf('WX') > -1) {
      Session.set('weChatFlag', true);
      Session.set('entranceFlag', 3);
    }
    // 4 小程序
    if (ijnpAppCode.indexOf('XCX') > -1) {
      Session.set('XCXFlag', true);
      Session.set('entranceFlag', 4);
    }
  }
  // 存储appId(机构id)
  if (to.query.appId) {
    global.appId = to.query.appId
  }
  // 存储wechatappid
  if (to.query.wechatappid) {
    Storage.set('WECHAT_APP_ID', to.query.wechatappid)
  }

  // 存储token
  if (to.query.token) {
    TokenManager.set(to.query.token)
  }

  // 存储orgCode
  if (to.query.orgCode) {
    global.orgCode = to.query.orgCode;
    Storage.set('orgCode', global.orgCode);
  }

  // 机构orgCode
  let orgCode = Storage.get('orgCode');
  if (orgCode) {
    global.orgCode = orgCode;
  }
  // 返校学校serviceCode
  if (to.query.serviceCode) {
    global.serviceCode = to.query.serviceCode;
    Storage.set('serviceCode', global.serviceCode);
  }
  // envFlagDebug
  if (to.query.envFlagDebug) {
    Storage.set('envFlagDebug', to.query.envFlagDebug);
  }
  // 获取appId名称
  let appIdName = global.checkAppId()
  //获取全局配置
  if (appIdName != 'appIdEmpty' && appIdName != 'SYSTEM') {
    // 存储获取全局配置
    Storage.set('appIdversion', JSON.stringify(version[appIdName]));
  }
  Vue.prototype.appIdName = appIdName
  if (Session.get('npLoginParams')) {
    // 赋值
    for (let [key, value] of Object.entries(Session.get('npLoginParams'))) {
      Vue.prototype[key] = value
    }
  }
  const u = navigator.userAgent.toLowerCase()
  // IOS或者微信
  if (u.indexOf("like mac os x") < 0 || u.match(/MicroMessenger/i) != 'micromessenger' || u.match(/WebP/i) ==
    "webp") {
    return false
  } else {
    if (to.path !== from.path && from.path != '/' && to.path !== '/' && from.path != '/wechatLogin' && to.path !=
      '/wechatLogin' && ('#' + to.path) != location.hash) {
      setTimeout(() => {
        location.assign('#' + to.fullPath)
      }, 20)
    }
  }
})
new Vue({
  router,
  store, i18n,
  render: h => h(App)
}).$mount('#app')